<template>
  <div class="content">
    <div class="set_wrap">
      <div class="setrow">
        <div class="row_t">用户咨询商品时</div>
        <div class="row_b">
          <el-radio-group v-model="radio">
            <el-radio :label="3">由名片关联的销售人员服务</el-radio>
            <el-radio :label="6">由商品专属客服服务</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="setrow">
        <div class="row_t">默认专属客服</div>
        <div class="row_b">
          <el-button type="primary" @click="settingsconsult">重新设置</el-button>
        </div>
      </div>
      <div class="setrow">
        <div class="row_t">默认专属客服</div>
      </div>
      <div class="condition">
        <div class="search_wrap">
          <el-form :inline="true" :model="form" class="form-inline">
            <el-form-item>
              <el-select v-model="value" placeholder="请选择分类">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-model="value" placeholder="请选择商品分类">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.user" placeholder="请输入商品名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="value" placeholder="请选择商品状态">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="form.user" placeholder="请输入客服人员名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"></el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="商品图片">
            <template slot-scope="scope">
              <div class="td_img">
                <img :src="scope.row.goods_thumb" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称"></el-table-column>
          <el-table-column prop="address" label="所属分类"></el-table-column>
          <el-table-column prop="address" label="商品类别"></el-table-column>
          <el-table-column label="商品状态">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.value" active-color="#2AA3F8" inactive-color="#ff4949"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="专属客服"></el-table-column>
          <el-table-column prop="address" label="职位"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- @click="handleClick(scope.row)" -->
              <el-button type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>

    <settingsConsultDialog :visible.sync="settingsconsultdialog" v-if="settingsconsultdialog"></settingsConsultDialog>
  </div>
</template>
<script>
import api from "@/api.js";
import settingsConsultDialog from "@/components/dialog/settingsConsultDialog.vue";
import { pagination } from "@/util/util.js";
export default {
  name: "consultationSetting",
  components: {
    settingsConsultDialog
  },
  data() {
    return {
      form: {},
      value: "",
      options: [],
      radio: "",
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      settingsconsultdialog: false
    };
  },
  methods: {
    // 重新设置
    settingsconsult() {
      this.settingsconsultdialog = true;
    },
    //初始化请求
    init() {
      this.page.pageindex = 1;
      this.querylist();
    },
    //查询列表
    querylist() {
      let params = {};
      this.axios
        .post(api.url, params)
        .then(response => {
          if (response.data.errorCode == 0) {
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist();
    }
  }
};
</script>

<style scoped>
.set_wrap{-webkit-box-shadow: none; box-shadow: none;}
</style>